<script>
import { get } from 'lodash'

export default {
  mounted() {
    let dynamicStylesTimeout = null
    const resettableHeightVars = ['top-banner-height', 'language-banner-height']

    const getElementHeight = (className, varName) => {
      const element = document.getElementsByClassName(className)
      const { offsetHeight } = get(element, '[0]') || {}
      let varValue = null

      if (offsetHeight) {
        varValue = `${offsetHeight}px`
      } else if (resettableHeightVars.includes(varName)) {
        varValue = '0px'
      }

      if (varValue && varValue !== document.documentElement.style.getPropertyValue('--' + varName)) {
        document.documentElement.style.setProperty('--' + varName, varValue)
      }
    }

    const getViewportHeight = () => {
      const height = get(window, 'innerHeight')
      if (height) {
        document.documentElement.style.setProperty('--viewport-inner-height-px', `${height}px`)
      }
    }

    const setHeights = () => {
      getViewportHeight()
      getElementHeight('HeaderMain', 'header-main-height')
      getElementHeight('HeaderMain--stickyOnMobile', 'header-main-mobile-height')
      getElementHeight('TopBanner', 'top-banner-height')
      getElementHeight('LanguageBanner', 'language-banner-height')
    }

    const getHeights = () => {
      window.clearTimeout(dynamicStylesTimeout)
      setHeights()
      dynamicStylesTimeout = setTimeout(setHeights, 500)
    }

    this.dynamicStylesGetHeights = getHeights
    this.dynamicStylesClearTimeout = () => window.clearTimeout(dynamicStylesTimeout)

    getHeights()
    window.addEventListener('resize', getHeights, { passive: true })
    window.addEventListener('orientationchange', getHeights, { passive: true })
  },

  beforeDestroy() {
    if (this.dynamicStylesGetHeights) {
      window.removeEventListener('resize', this.dynamicStylesGetHeights)
      window.removeEventListener('orientationchange', this.dynamicStylesGetHeights)
    }

    if (this.dynamicStylesClearTimeout) {
      this.dynamicStylesClearTimeout()
    }
  },
}
</script>
